import './liveTrackVehicles.css';
import {useState} from "react";

const LiveTrackVehicles = ({vehicles = [], handleVehicleSelect = (vehicle) => {}}) => {
    const [activeVehicle, setActiveVehicle] = useState();

    const onVehicleSelect = (vehicle) => {
        handleVehicleSelect(vehicle);
        setActiveVehicle(vehicle);
    }

    return (
        <ul className={'liveTrack-vehicle-list font-14'}>
            {vehicles?.map((vehicle) =>
                <li key={vehicle.vehicleId}
                    onClick={event => onVehicleSelect(vehicle)}
                    className={`${vehicle?.vehicleId === activeVehicle?.vehicleId ? 'selected' : ''}`}>
                    <div className="vehicle-header">
                        <ul className="separator gap-15  sf-medium margin-b-5">
                            <li className={'to sf-bold font-15'}>{vehicle.plateNo}</li>
                            <li>Avg Speed: <span className={'blue-color'}>19 Km/h</span></li>
                        </ul>
                        <div className="trip-details">
                            <ul className="separator gap-20 margin-b-5">
                                <li>Vehicle Type: HMV</li>
                                <li>Model: Eicher</li>
                            </ul>
                            <div className="font-12 grey-color">Last Updated : 6 Dec, 07:30 AM</div>
                        </div>
                    </div>
                </li>
            )}
        </ul>
    )
}

export default LiveTrackVehicles;
